/* Garde du paiement (audit 27/09/2026) : compte les écritures /cart/* en vol,
 * pour ne jamais partir au paiement sur un panier en cours de modification. */
window.MMCartOps = window.MMCartOps || (() => {
  let n = 0;
  const attentes = [];
  const fini = () => { n -= 1; if (n <= 0) { n = 0; attentes.splice(0).forEach((r) => r()); } };
  const orig = window.fetch;
  window.fetch = function (res, init) {
    const url = typeof res === 'string' ? res : (res && res.url) || '';
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      n += 1;
      const p = orig.apply(this, arguments);
      p.then(fini, fini);
      return p;
    }
    return orig.apply(this, arguments);
  };
  return { get calme() { return n === 0; }, quiet: () => (n === 0 ? Promise.resolve() : new Promise((r) => { attentes.push(r); })) };
})();

/* MM Custom Cart Drawer — slides up, controls open/close + cross-sell slider + AJAX add-to-cart */
(function () {
  /* Entrée dans un champ quantité (tiroir ou page panier) envoyait le formulaire du panier
     avec son premier bouton, « Passer au paiement » : le client partait au paiement au lieu
     de mettre la quantité à jour (audit du 27/09/2026, déjà le cas en ligne). Entrée
     valide désormais le champ, comme une sortie du champ. */
  if (!window.mmQuantiteEntree) {
    window.mmQuantiteEntree = true;
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      const champ = e.target;
      if (!(champ instanceof HTMLInputElement)) return;
      if (!champ.closest('[data-mm-qty], quantity-input, .cart-item__quantity')) return;
      if (!champ.closest('cart-drawer, cart-items, form[action*="/cart"]')) return;
      e.preventDefault();
      champ.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  class MMCartDrawer extends HTMLElement {
    constructor() {
      super();
      this.bindCartIcon();
      this.bindAll();
      document.addEventListener('keyup', (e) => e.key === 'Escape' && this.classList.contains('is-open') && this.close());
      this.enqueue(async () => {
        if (await MMCartGift.sync()) await this.render({ syncGift: false });
      });
    }

    // La page /cart publie ses propres écritures : le tiroir s'y aligne sans les rediffuser,
    // et sans relancer la règle du cadeau qu'elle vient d'appliquer.
    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') return this.refresh({ notify: false, syncGift: false });
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    bindAll() {
      this.overlay = this.querySelector('[data-mm-overlay]');
      this.closeBtns = this.querySelectorAll('[data-mm-close]');
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      this.closeBtns.forEach((b) => b.addEventListener('click', () => this.close()));
      this.initSlider();
      this.bindAddButtons();
      this.bindCardForms();
      this.bindRemove();
      this.bindQty();
      this.bindCheckout();
      if (this.classList.contains('is-open')) this.chargerImages();
    }

    /* Les images des suggestions arrivent sans src (data-mm-src, voir mm-card-media) :
     * tiroir fermé, elles étaient téléchargées sur chaque page pour rien. Posées ici à
     * l'ouverture, et après chaque nouveau rendu du tiroir ouvert (bindAll). */
    chargerImages() {
      this.querySelectorAll('img[data-mm-src]').forEach((img) => {
        if (img.dataset.mmSrcset) img.srcset = img.dataset.mmSrcset;
        img.src = img.dataset.mmSrc;
        img.removeAttribute('data-mm-src');
        img.removeAttribute('data-mm-srcset');
      });
    }

    bindCartIcon() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
      // Annoncé comme un bouton : la barre d'espace doit l'ouvrir aussi (elle faisait défiler la page).
      cartLink.addEventListener('keydown', (e) => {
        if (e.key !== ' ' && e.key !== 'Spacebar') return;
        e.preventDefault();
        this.open();
      });
    }

    /*
     * Ouverture et fermeture accessibles.
     *
     * Le tiroir portait `aria-hidden="true"` en dur dans le markup et seule la classe
     * `is-open` basculait : un lecteur d'ecran ne voyait donc JAMAIS le contenu du
     * panier, et le focus pouvait entrer dans une zone `aria-hidden`, etat interdit
     * par la specification ARIA. L'attribut suit desormais l'etat reel.
     *
     * Le piege de focus n'est pas ecrit a la main : `inert` sur les freres du tiroir
     * retire tout le reste de la page de l'ordre de tabulation ET de l'arbre
     * d'accessibilite, ce qui donne le piege sans avoir a intercepter Tab et sans
     * pouvoir se desynchroniser du DOM. `inert` est Baseline Widely Available depuis
     * octobre 2025 ; la garde `'inert' in HTMLElement.prototype` laisse simplement le
     * comportement d'avant sur un navigateur qui ne le connait pas.
     */
    open() {
      if (this.classList.contains('is-open')) return;
      /* Ouvert par « Ajouter au panier », le bouton est désactivé pendant l'ajout et le focus
         est déjà retombé sur <body> : on retient alors le bouton transmis par la fiche. */
      const actif = document.activeElement;
      this.lastFocused = actif && actif !== document.body ? actif : this.activeElement || null;
      this.activeElement = null;
      this.removeAttribute('aria-hidden');
      this.classList.add('is-open');
      this.chargerImages();
      document.body.classList.add('overflow-hidden');
      this.setBackgroundInert(true);
      this.focusPanel();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      this.setBackgroundInert(false);
      // Rendre le focus a l'element qui a ouvert le tiroir, jamais au debut de page.
      let retour = this.lastFocused;
      if (!retour || retour === document.body || !retour.isConnected) retour = document.querySelector('[data-mm-add-to-cart]');
      if (retour && typeof retour.focus === 'function') {
        retour.focus({ preventScroll: true });
      }
    }

    /* Marque inertes tous les freres du tiroir, en memorisant ceux qui l'etaient deja
     * pour ne pas les reveiller a la fermeture. Le wrapper de section genere par
     * Shopify est l'ancetre reel du tiroir : c'est lui qu'il faut epargner. */
    setBackgroundInert(on) {
      if (!('inert' in HTMLElement.prototype)) return;
      const root = this.closest('#shopify-section-cart-drawer') || this;
      Array.from(document.body.children).forEach((el) => {
        if (el === root || el.contains(root)) return;
        if (on) {
          if (el.inert) el.dataset.mmWasInert = 'true';
          el.inert = true;
        } else if (el.dataset.mmWasInert === 'true') {
          delete el.dataset.mmWasInert;
        } else {
          el.inert = false;
        }
      });
    }

    focusPanel() {
      const panel = this.querySelector('[role="dialog"]');
      if (!panel) return;
      if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
      panel.focus({ preventScroll: true });
      /* Pendant la transition d'ouverture, le panneau peut être encore invisible et refuser
         le focus (resté sur <body>, audit du 27/09/2026) : second essai une fois ouvert. */
      if (!this.contains(document.activeElement)) {
        setTimeout(() => {
          if (this.classList.contains('is-open') && !this.contains(document.activeElement)) panel.focus({ preventScroll: true });
        }, 350);
      }
    }

    initSlider() {
      const slider = this.querySelector('[data-mm-slider]');
      if (!slider) return;
      const track = slider.querySelector('[data-mm-track]');
      const prev = this.querySelector('[data-mm-prev]');
      const next = this.querySelector('[data-mm-next]');
      const counter = this.querySelector('[data-mm-counter]');
      const slides = track ? track.children : [];
      if (!track || slides.length === 0) return;

      this.slideIndex = 0;
      const update = () => {
        const slide = slides[0];
        const slideW = slide.getBoundingClientRect().width + 12; // gap
        const sliderInner = slider.clientWidth - 40; // account for horizontal padding 20px*2
        /* floor et non round : à 360 px, 1,5 carte visible comptait pour 2 et la dernière
           carte restait coupée, son bouton panier hors écran (audit mobile du 27/09/2026).
           + 12 : l'écart après la dernière carte visible ne compte pas. */
        const visible = Math.max(1, Math.floor((sliderInner + 12) / slideW));
        const max = Math.max(0, slides.length - visible);
        if (this.slideIndex > max) this.slideIndex = max;
        track.style.transform = `translateX(${-this.slideIndex * slideW}px)`;
        if (prev) prev.disabled = this.slideIndex === 0;
        if (next) next.disabled = this.slideIndex >= max;
        /* Le compteur compte les POSITIONS et non les cartes : en tablette, deux cartes visibles
           à la fois, il s'arrêtait à « 2 / 3 ». Tout visible : flèches et compteur masqués
           (sans décaler le titre). */
        if (counter) counter.textContent = `${this.slideIndex + 1} / ${max + 1}`;
        const nav = this.querySelector('.mm-cart__crosssell-nav');
        if (nav) nav.style.visibility = max === 0 ? 'hidden' : '';
      };
      if (prev) prev.addEventListener('click', () => { this.slideIndex--; update(); });
      if (next) next.addEventListener('click', () => { this.slideIndex++; update(); });
      /* Au clavier, le navigateur faisait défiler le cadre (scrollLeft) pour montrer la carte
         qui reçoit le focus, sans que le compteur ni les flèches suivent (audit du 27/09/2026).
         Le cadre ne défile jamais : c'est la position du carrousel qui va à la carte. */
      slider.addEventListener('scroll', () => { if (slider.scrollLeft) slider.scrollLeft = 0; });
      track.addEventListener('focusin', (e) => {
        const carte = e.target.closest('[data-mm-track] > *');
        if (!carte) return;
        const index = Array.prototype.indexOf.call(slides, carte);
        const slideW = slides[0].getBoundingClientRect().width + 12;
        const visible = Math.max(1, Math.floor((slider.clientWidth - 40 + 12) / slideW));
        if (index < this.slideIndex) this.slideIndex = index;
        else if (index >= this.slideIndex + visible) this.slideIndex = index - visible + 1;
        slider.scrollLeft = 0;
        update();
      });
      // Un seul écouteur de redimensionnement, celui du contenu actuel (le tiroir est re-rendu).
      if (this.majSlider) window.removeEventListener('resize', this.majSlider);
      this.majSlider = update;
      window.addEventListener('resize', update);
      update();
    }

    bindAddButtons() {
      this.querySelectorAll('[data-mm-add]').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const id = btn.dataset.variantId;
          if (!id) return;
          btn.disabled = true;
          btn.dataset.originalText = btn.textContent;
          btn.textContent = /^fr/i.test(document.documentElement.lang || '') ? 'Ajout…' : 'Adding…';
          try {
            const body = new FormData();
            body.append('id', id);
            body.append('quantity', '1');
            await this.enqueue(async () => {
              const res = await fetch(`${routes.cart_add_url}.js`, { method: 'POST', body });
              if (!res.ok) throw new Error('Add failed');
              await this.render({ open: true });
            });
          } finally {
            btn.disabled = false;
            btn.textContent = btn.dataset.originalText || (window.mmI18n && window.mmI18n.cartAdd) || 'Ajouter au panier';
          }
        });
      });
    }

    bindCardForms() {
      // Intercept cross-sell card add-to-cart form submissions (snippet mm-fc-card)
      this.querySelectorAll('.mm-featured-collection__card form[action*="/cart/add"]').forEach((form) => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          const submitBtn = form.querySelector('button[type="submit"]');
          const idInput = form.querySelector('input[name="id"]');
          if (!idInput || !idInput.value) return;
          if (submitBtn) submitBtn.disabled = true;
          try {
            const body = new FormData(form);
            await this.enqueue(async () => {
              const res = await fetch(`${routes.cart_add_url}.js`, { method: 'POST', body });
              if (!res.ok) throw new Error('Add failed');
              await this.render({ open: true });
            });
          } finally {
            if (submitBtn) submitBtn.disabled = false;
          }
        });
      });
      // Prevent the wrapping card link from navigating when clicking anywhere inside the card
      this.querySelectorAll('.mm-featured-collection__card-link').forEach((link) => {
        link.addEventListener('click', (e) => e.preventDefault());
      });
    }

    /*
     * Toute écriture passe par la file UNIQUE de la page (`MMCartLines`), partagée avec
     * /cart : deux files séparées laissaient un + du tiroir partir d'un DOM que la page
     * était en train de remplacer, et le dernier arrivé gagnait. Le tiroir reste occupé
     * (`aria-busy`) tant qu'il reste quelque chose en attente.
     */
    enqueue(task) {
      this.setAttribute('aria-busy', 'true');
      const released = () => {
        if (MMCartLines.idle) this.removeAttribute('aria-busy');
      };
      const run = MMCartLines.enqueue(task);
      run.then(released, (error) => {
        released();
        this.showError(error);
      });
      return run;
    }

    refresh(options) {
      return this.enqueue(() => this.render(options)).catch(() => {});
    }

    /* Relit le panier après une écriture : applique d'abord la règle du cadeau, puis rend
     * le tiroir UNE fois sur l'état final, et prévient la page /cart (sauf si c'est elle
     * qui vient d'écrire, auquel cas elle a déjà appliqué la règle). Ne s'appelle que
     * depuis la file. */
    async render(options) {
      if (!(options && options.syncGift === false)) await MMCartGift.sync();
      const res = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
      // Après +, − ou ✕ la liste garde sa position ; après un ajout (ouverture), elle repart du haut.
      this.applySections(await res.json(), { garderDefilement: !(options && options.open) });
      if (options && options.open) this.open();
      if (!(options && options.notify === false)) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer' });
      document.dispatchEvent(new CustomEvent('mm:cart-updated'));
    }

    applySections(sections, reglages) {
      const newDrawer = sections['cart-drawer'] && new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
      if (newDrawer) {
        // Re-rendu : les vignettes déjà vues repartaient en lazy et clignotaient (audit 27/09).
        newDrawer.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
        Array.from(newDrawer.attributes).forEach((attr) => {
          if (attr.name.startsWith('data-')) this.setAttribute(attr.name, attr.value);
        });
        const focus = this.readFocus();
        /* Remplacer le contenu pendant que le focus y est laissait Firefox tourner en rond
           entre « Fermer » et la zone défilante à la touche Tab (ajout automatique du coffret,
           audit du 27/09/2026) : on lâche le focus avant, on le repose après. */
        if (this.contains(document.activeElement)) document.activeElement.blur();
        /* Sur téléphone, la liste remontait tout en haut après chaque +, − ou ✕ et la ligne
           modifiée sautait sous le doigt (audit du 27/09/2026) : on garde sa position. */
        const ancienCorps = this.querySelector('.mm-cart__body');
        const defilement = reglages && reglages.garderDefilement && ancienCorps ? ancienCorps.scrollTop : 0;
        this.innerHTML = newDrawer.innerHTML;
        if (defilement) {
          const nouveauCorps = this.querySelector('.mm-cart__body');
          if (nouveauCorps) nouveauCorps.scrollTop = defilement;
        }
        this.bindAll();
        this.restoreFocus(focus);
        // Tiroir ouvert : le focus ne doit jamais retomber sur la page (ajout depuis « Découvrez aussi »).
        if (this.classList.contains('is-open') && !this.contains(document.activeElement)) this.focusPanel();
      }
      const bubble = document.querySelector('#cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const inner = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }
    }

    /* Le rendu remplace tout le tiroir : sans cela, le focus clavier retombait sur la page
     * après chaque + ou −. La ligne se retrouve par son GROUPE : par variante, le focus
     * partait sur la ligne offerte quand la cliente achetait AUSSI le coffret, et le geste
     * suivant incrémentait le cadeau. Ligne disparue : le focus revient au panneau. */
    readFocus() {
      const el = document.activeElement;
      if (!el || !this.contains(el)) return null;
      const line = el.closest('.mm-cart__item');
      const control = ['data-mm-plus', 'data-mm-minus', 'data-mm-remove'].find((attr) => el.hasAttribute(attr));
      return { group: line && line.dataset.group, control: control ? `[${control}]` : el.matches('[data-mm-qty] input') ? '[data-mm-qty] input' : null };
    }

    restoreFocus(focus) {
      if (!focus) return;
      const line = focus.group && this.querySelector(`.mm-cart__item[data-group="${focus.group}"]`);
      const target = line && focus.control && line.querySelector(focus.control);
      if (target) target.focus();
      else this.focusPanel();
    }

    bindRemove() {
      this.querySelectorAll('[data-mm-remove]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.changeQuantity(this.groupOf(btn), { absolute: 0 });
        });
      });
    }

    bindQty() {
      this.querySelectorAll('[data-mm-qty]').forEach((wrap) => {
        const group = this.groupOf(wrap);
        const input = wrap.querySelector('input');
        const minus = wrap.querySelector('[data-mm-minus]');
        const plus = wrap.querySelector('[data-mm-plus]');
        if (minus) minus.addEventListener('click', () => this.changeQuantity(group, { delta: -1 }));
        if (plus) plus.addEventListener('click', () => this.changeQuantity(group, { delta: 1 }));
        if (input) input.addEventListener('change', () => this.changeQuantity(group, { absolute: Math.max(0, parseInt(input.value, 10) || 0) }));
      });
    }

    /* Toujours intercepter le clic « Passer au paiement » : on attend la fin des écritures
     * en vol et de la file, on applique une dernière fois la règle du cadeau, puis on
     * soumet le formulaire re-rendu. Sans cela, un clic rapide après l'ajout du 2e extrait
     * partait au paiement sans le Discovery Set, voire écrasait l'ajout en vol avec les
     * quantités affichées (audit 27/09/2026, reproduit 3/3). Garde-fou : 8 s maximum. */
    bindCheckout() {
      const btn = this.querySelector('.mm-cart__checkout');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.paiementEnCours) return;
        this.paiementEnCours = true;
        btn.setAttribute('aria-busy', 'true');
        const partir = () => {
          const form = document.getElementById('CartDrawer-Form');
          if (!form) { window.location.href = '/checkout'; return; }
          let champ = form.querySelector('input[name="checkout"]');
          if (!champ) {
            champ = document.createElement('input');
            champ.type = 'hidden';
            champ.name = 'checkout';
            champ.value = '';
            form.appendChild(champ);
          }
          form.submit();
        };
        const stabilise = MMCartOps.quiet()
          .then(() => MMCartLines.pending)
          .then(() => MMCartOps.quiet())
          .then(() => this.enqueue(async () => {
            if (await MMCartGift.sync()) await this.render({ syncGift: false, notify: false });
          }))
          .catch(() => {});
        Promise.race([stabilise, new Promise((r) => setTimeout(r, 8000))]).then(partir, partir);
      });
    }

    groupOf(element) {
      const line = element.closest('.mm-cart__item');
      return line ? line.dataset.group : '';
    }

    showError(error) {
      const box = this.querySelector('[data-mm-error]');
      /* Une erreur technique (réponse HTML au lieu de JSON, réseau coupé) affichait son message
         brut en anglais, « JSON.parse: unexpected character… » (audit du 27/09/2026) : on affiche
         le message traduit du thème. Les refus de Shopify (stock insuffisant…) restent affichés. */
      const technique = !error || error instanceof SyntaxError || error instanceof TypeError || /JSON|fetch|network/i.test(error.message || '');
      if (box) box.textContent = technique ? window.cartStrings.error : error.message;
    }

    /*
     * Une ligne se désigne par son GROUPE, jamais par sa position ni par des clés lues au
     * clic : le cadeau s'insère en tête, et la remise change les clés à chaque écriture.
     * Le geste est mis en file et ne lit la ligne — ses clés, sa quantité — qu'au moment
     * de partir : un second clic pendant une écriture n'est donc plus avalé en silence,
     * il s'ajoute au précédent. Un refus de Shopify se dit à la cliente au lieu de finir
     * dans la console.
     */
    changeQuantity(group, { delta, absolute } = {}) {
      /* Retour visuel immédiat : la ligne touchée passe en attente jusqu'au re-rendu (audit 27/09). */
      this.querySelectorAll('.mm-cart__item').forEach((l) => { if (l.dataset.group === group) l.setAttribute('aria-busy', 'true'); });
      if (!group) return Promise.resolve();
      return this.enqueue(async () => {
        const line = this.querySelector(`.mm-cart__item[data-group="${group}"]`);
        if (!line) return;
        const input = line.querySelector('[data-mm-qty] input');
        const current = input ? parseInt(input.value, 10) || 0 : 0;
        const quantity = absolute === undefined ? Math.max(0, current + delta) : absolute;
        const response = await fetch(`${routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: MMCartLines.updates(line.dataset.keys, quantity) }),
        });
        const state = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(state.description || state.message || window.cartStrings.error);
        await this.render();
      }).catch(() => {});
    }

    // Compatibility with Dawn product-form.js
    getSectionsToRender() {
      return [
        { id: 'cart-drawer', selector: 'cart-drawer' },
        { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
      ];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    /* Appelé par la fiche produit, qui ouvre le tiroir juste après, de façon synchrone :
     * quand la file est libre, le contenu de l'ajout est appliqué TOUT DE SUITE, sinon le
     * tiroir s'ouvrait sur son contenu d'avant jusqu'à ce que la file se vide. */
    renderContents(parsedState) {
      const sections = parsedState && parsedState.sections;
      if (!sections || !sections['cart-drawer']) return this.refresh();
      const appliedNow = MMCartLines.idle;
      if (appliedNow) this.applySections(sections);
      return this.enqueue(async () => {
        if (!appliedNow) this.applySections(sections);
        this.open();
        if (await MMCartGift.sync()) await this.render({ syncGift: false });
      }).catch(() => {});
    }
  }

  customElements.define('cart-drawer', MMCartDrawer);
})();
